import { __extends } from "tslib";
import { fetchFrequentlyAskedQuestions } from '@gn-audio/core/api/knowledge-base';
import { FaqItem } from '../models/faq-item';
import { FaqSpotBaseController } from '../models/faq-spot-base.controller';
import { createFaqFilter } from '../utils/create-faq-filter';
var AllFaqsSpotController = (function (_super) {
    __extends(AllFaqsSpotController, _super);
    function AllFaqsSpotController($scope, $q, productContextService, siteLanguage) {
        var _this = _super.call(this, $scope, productContextService, siteLanguage) || this;
        _this.$q = $q;
        return _this;
    }
    AllFaqsSpotController.prototype.$onInit = function () {
        var _this = this;
        _super.prototype.$onInit.call(this);
        this.productContextService
            .subscribe()
            .then(null, null, function (group) {
            if (!group) {
                return;
            }
            _this.$scope.limit = 5;
            _this.$scope.initialLimit = _this.$scope.limit;
            var topFaqPromise = fetchFrequentlyAskedQuestions(group.groupId, null, createFaqFilter(group, _this.$scope.limit));
            var allFaqPromise = fetchFrequentlyAskedQuestions(group.groupId);
            _this.$q.when(Promise.all([topFaqPromise, allFaqPromise]))
                .then(function (_a) {
                var topFaqItems = _a[0], allFaqItems = _a[1];
                _this.$scope.faqItems = (topFaqItems || []).map(function (x) { return new FaqItem(x); });
                _this.$scope.allFaqItems = (allFaqItems || []).map(function (x) { return new FaqItem(x); });
                _this.$scope.initialFaqItems = _this.$scope.faqItems.slice();
            })
                .then(function () {
                _this.showMoreAvailable = _this.$scope.allFaqItems.length > _this.$scope.limit;
                _this.showAllAvailable = !_this.showMoreAvailable;
            });
        });
    };
    AllFaqsSpotController.$inject = [
        '$scope',
        '$q',
        'productContextService',
        'siteLanguage',
    ];
    return AllFaqsSpotController;
}(FaqSpotBaseController));
export { AllFaqsSpotController };
